import { render, staticRenderFns } from "./materiality-matrix.vue?vue&type=template&id=390def96&scoped=true"
import script from "./materiality-matrix.vue?vue&type=script&lang=js"
export * from "./materiality-matrix.vue?vue&type=script&lang=js"
import style0 from "./materiality-matrix.vue?vue&type=style&index=0&id=390def96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390def96",
  null
  
)

export default component.exports